import React from "react";
import "./MobileDashboardCard.css";
import { Link } from "react-router-dom";
import image1 from "./Picture1.png";
import image2 from "./Picture2.png";
const MobileDashboardCard = () => {
  return (
    <>
      <section className="pt-3 pb-2 mobile-home-sft-area text-center">
        <div className="container">
          <div className="mobile-home-sft ">
            <div className="d-flex align-items-center justify-content-between">
              <Link to="/user/assets/deposit">
                <i
                  className="fa-solid fa-money-bill-1-wave"
                  style={{ color: "#536DFE" }}
                ></i>
                <i className=""></i>
                <p>Deposit</p>
              </Link>
              <Link to="/user/invest/plan">
                <i
                  className="fa-solid fa-circle-dollar-to-slot"
                  style={{ color: "#ff00f2" }}
                ></i>
                <p>Invest Plan</p>
              </Link>
              <Link to="/user/new/coin">
                <i className="fa-solid fa-coins" style={{ color: "green" }}></i>
                <p>New Coin</p>
              </Link>
              <Link to="/user/apply/loan">
                <i
                  className="fa-solid fa-hand-holding-dollar"
                  style={{ color: "#a40656" }}
                ></i>
                <p>Loan</p>
              </Link>
              <Link to="/user/bitcoin/mining">
                <i
                  className="fa-brands fa-bitcoin"
                  style={{ color: "orange" }}
                ></i>
                <p>B. Mining</p>
              </Link>
            </div>
          </div>
          <div className="mobile-home-sft ">
            <div className="d-flex align-items-center justify-content-between">
              <Link to="/user/gold/mining">
                <i
                  className="fa-solid fa-ring"
                  style={{ color: "#FFD700" }}
                ></i>

                <p>G. Mining</p>
              </Link>
              <Link to="/user/nft">
               <div className="image">
                 <img src={image2} alt="" />
               </div>
                <p>NFT</p>
              </Link>

              <Link to="/user/stocks">
                <i className="fa-brands fa-meta" style={{ color: "blue" }}></i>
                <p>xStocks</p>
              </Link>

              <Link to="/user/gift">
                <i
                  className="fa-solid fa-gifts"
                  style={{ color: "#7ba315" }}
                ></i>
                <p>Gift</p>
              </Link>

              <Link to="/user/recovery">
                <div className="image">
                 <img src={image1} alt="" />
               </div>
                <p>Recovery</p>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MobileDashboardCard;
